import { create } from 'zustand';
import { httpClient } from '@alvo/api';

interface Agency {
  id: string;
  name: string;
  code: string;
  commission_model?: string;
  default_rate?: number;
}

interface AgencyStore {
  agencies: Agency[];
  loading: boolean;
  fetch: () => Promise<void>;
}

export const useAgencyStore = create<AgencyStore>((set, get) => ({
  agencies: [],
  loading: false,
  fetch: async () => {
    if (get().agencies.length > 0) return;
    set({ loading: true });
    try {
      const res = await httpClient.get('/agencies');
      const raw = res as any;
      set({ agencies: Array.isArray(raw) ? raw : raw.data?.data || raw.data || [] });
    } catch (e) {
      console.error('Failed to fetch agencies', e);
    } finally {
      set({ loading: false });
    }
  }
}));
